module.exports = __webpack_public_path__ + "img/29.c95f4dae.jpg";